import React, {useState} from 'react';
import * as S from './MyCash.styles';
import IconSelector from '@ibibo/icon-selector';
import IncentiveBalance from './IncentiveBalance/IncentiveBalance';
import formatPrice from '../../../../utils/formatPrice';
import {getCookie} from '../../../../utils/getCookie';

const MyCash = ({walletBreakup}) => {
  const {
    promo_balance,
    wallet_balance,
    incentive_amount,
    wallet_last_recharged = '',
    promo_first_expiry = '',
  } = walletBreakup;
  const ccdeCookie = getCookie('ccde');
  return (
    <S.MyCashTile>
      <li>
        {ccdeCookie === 'AE' ? (
          <img src={'https://assets-gos3.goibibo.com/myp_MYCASH_AED-1678423545.svg'} />
        ) : (
          <IconSelector iconKey="mycash" />
        )}
        <S.Details>
          <S.Heading>My Cash</S.Heading>
          {wallet_last_recharged && (
            <S.WalletCashInfoText>{wallet_last_recharged}</S.WalletCashInfoText>
          )}
        </S.Details>
        {typeof wallet_balance !== 'undefined' ? (
          <S.Amount>
            {ccdeCookie === 'AE' ? (
              <S.AedText>AED </S.AedText>
            ) : (
              <IconSelector
                iconKey="rupee"
                props={{width: '1.4rem', height: '1.4rem', fill: '#000'}}
              />
            )}
            {wallet_balance.toLocaleString('en-In')}
          </S.Amount>
        ) : (
          <S.WalletCashTextLoader />
        )}
      </li>
      {!!incentive_amount && (
        <li className="noPadding">
          <IncentiveBalance
            heading="Cashback Balance"
            subHeading="Included in your My Cash Balance"
            price={formatPrice(incentive_amount, ccdeCookie === 'AE' ? 'AED' : 'INR')}
          />
        </li>
      )}
      <li>
        {ccdeCookie === 'AE' ? (
          <img src="https://assets-gos3.goibibo.com/myp_PromoCash_SVG_AED-1678689298.svg" />
        ) : (
          <IconSelector iconKey="rewardbonus" />
        )}
        <S.Details>
          <S.Heading>Promo Cash</S.Heading>
          {promo_first_expiry && <S.DescText>{promo_first_expiry}</S.DescText>}
        </S.Details>
        {typeof promo_balance !== 'undefined' ? (
          <S.Amount>
            {ccdeCookie === 'AE' ? (
              <S.AedText>AED </S.AedText>
            ) : (
              <IconSelector
                iconKey="rupee"
                props={{width: '1.4rem', height: '1.4rem', fill: '#000'}}
              />
            )}
            {promo_balance.toLocaleString('en-In')}
          </S.Amount>
        ) : (
          <S.WalletCashTextLoader />
        )}
      </li>
    </S.MyCashTile>
  );
};

export default MyCash;
